export class FieldPathUtils {
  /**
   * Gets the path without the leaf. Returns an empty string if the path is a root path.
   * See: FieldContext tailless().
   * @param path the path
   * @return the path without the leaf part
   */
  static tailless(path: string): string {
    return path.split('.').slice(0, -1).join('.');
  }

  /**
   * Gets the leaf of the path (e.g. candidates from invenias.assignmentsListItem.candidates).
   * Returns the original path if the path is a root path.
   * See: FieldContext leaf().
   * @param path the path
   * @return the leaf part of the path
   */
  static leaf(path: string): string {
    return path.split('.').slice(-1)[0];
  }

  /**
   * Gets the path without the leaf. Returns the original path if the path is a root path.
   * @param path the path
   * @return the path without the leaf part or the original path
   */
  static getPathToField(path: string): string {
    const lastDotIndex = path.lastIndexOf('.');
    return lastDotIndex < 0 ? path : path.substr(0, lastDotIndex);
  }
}
